'use strict';

angular.module('shiftTraderApp')
  .service('UsersStore', ['$log', '$rootScope', 'Session', '$q', '$timeout', 'Users',
    function ($log, $rootScope, Session, $q, $timeout, Users) {
      var records = [];
      var cacheLastUpdated = null;
      var maxCacheAgeInSeconds = 60;
      var defers = [];
      var waitingOnRequest = false;

      var that = this;

      this.flush = function() {
        records = [];
        cacheLastUpdated = null;
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
      });

      function updateCache(recs) {
        records = recs;
        cacheLastUpdated = moment.utc().unix();
      }

      function isCacheValid() {
        return !lodash.isNull(cacheLastUpdated) &&
          ((cacheLastUpdated + maxCacheAgeInSeconds) > moment.utc().unix());
      }

      this.getAll = function() {
        var deferred = $q.defer();

        if (isCacheValid()) {
          deferred.resolve(records);
        } else {
          defers.push(deferred);

          if (!waitingOnRequest) {
            waitingOnRequest = true;

            Users.getAll()
              .then(function(users) {
                updateCache(users);

                while (defers.length > 0) {
                  var d = defers.shift();
                  d.resolve(records);
                }

                waitingOnRequest = false;
              }, function(response) {
                while (defers.length > 0) {
                  var d = defers.shift();
                  d.reject(response);
                }

                waitingOnRequest = false;
              });
          }
        }

        return deferred.promise;
      };

      this.getRecordById = function(recordId) {
        var deferred = $q.defer();
        that.getAll()
          .then(function(users) {
            deferred.resolve(lodash.find(users, {id: parseInt(recordId)}));
          }, function(response) {
            deferred.reject(response);
          });

        return deferred.promise;
      };

  }]);
